import React from 'react';
import { Layout } from '../components/Layout';
import { ProcessGrid } from '../components/ProcessGrid';
import { TransformationSlider } from '../components/TransformationSlider';
export function ProcessPage() {
  return <Layout data-id="element-499">
      <div className="py-24 px-6 bg-alabaster border-b-3 border-charcoal" data-id="element-500">
        <div className="max-w-7xl mx-auto" data-id="element-501">
          <h1 className="text-4xl sm:text-6xl md:text-8xl font-bold mb-8" data-id="element-502">
            The 48-Hour <br data-id="element-503" />
            <span className="italic font-serif font-normal text-espresso" data-id="element-504">
              Transformation
            </span>
          </h1>
          <p className="text-xl text-charcoal/60 max-w-2xl leading-relaxed" data-id="element-505">
            Our proprietary refacing process eliminates the need for messy
            demolition, saving you time, money, and stress while delivering a
            brand-new kitchen aesthetic.
          </p>
        </div>
      </div>
      <ProcessGrid data-id="element-506" />
      <TransformationSlider data-id="element-507" />
      <section className="py-24 px-6 bg-white" data-id="element-508">
        <div className="max-w-4xl mx-auto space-y-16" data-id="element-509">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-510">
            <div className="border-3 border-charcoal p-8" data-id="element-511">
              <h3 className="text-2xl font-bold mb-4" data-id="element-512">Day 1: Preparation</h3>
              <p className="text-charcoal/60" data-id="element-513">
                We remove all existing doors and drawer fronts. Our technicians
                then apply high-pressure veneers to your existing cabinet boxes,
                ensuring a perfect color match and seamless finish.
              </p>
            </div>
            <img src="https://cdn.magicpatterns.com/uploads/ovdZy1i9s2PCUVtjejdLkf/pexels-curtis-adams-1694007-3935326_(1).jpg" alt="Preparation" className="border-3 border-charcoal h-64 object-cover w-full" data-id="element-514" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-515">
            <img src="https://images.pexels.com/photos/8186477/pexels-photo-8186477.jpeg?auto=compress&cs=tinysrgb&w=800" alt="Installation" className="border-3 border-charcoal h-64 object-cover w-full md:order-2" data-id="element-516" />
            <div className="border-3 border-charcoal p-8 md:order-1" data-id="element-517">
              <h3 className="text-2xl font-bold mb-4" data-id="element-518">Day 2: Installation</h3>
              <p className="text-charcoal/60" data-id="element-519">
                We install your custom-made doors, drawer fronts, and premium
                hardware. We finish with a thorough cleaning and a final quality
                inspection to ensure every detail is perfect.
              </p>
            </div>
          </div>
        </div>
      </section>
    </Layout>;
}